import type { StaticNavigationNavigationItemDto } from '@ori/static-api-client-react';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import { useCallback, useMemo, useState } from 'react';

import { SubCategory } from '../CategoryContent/SubCategory';
import { BEST_OFFERS_SUBMENU_MOBILE } from './constants';
import { MobileRoot } from './styles';
import type { BestOffersProps } from './types';

export const MobileBestOffers: FC<BestOffersProps> = ({ content }) => {
  const [activeSubCategory, setActiveSubCategory] = useState<StaticNavigationNavigationItemDto['url'] | undefined>('');

  const handleSubCategoryClick = useCallback(
    (subCategory?: StaticNavigationNavigationItemDto['url']) => {
      if (subCategory === activeSubCategory) {
        setActiveSubCategory('');
      } else {
        setActiveSubCategory(subCategory);
      }
    },
    [activeSubCategory],
  );

  const { getTestId } = useTestId();

  const itemsList = useMemo(
    () =>
      content?.map((item) => (
        <SubCategory
          key={item.id}
          boldText
          isBestOffers
          subCategory={item}
          displayArrowIcon={item.children.length > 0}
          activeSubCategory={activeSubCategory}
          handleSubCategoryClick={handleSubCategoryClick}
        />
      )),
    [content, activeSubCategory, handleSubCategoryClick],
  );

  return <MobileRoot data-testid={getTestId(BEST_OFFERS_SUBMENU_MOBILE)}>{itemsList}</MobileRoot>;
};
